import React from 'react';

import { EmptyState } from '@copilot/ui';
import Loader from '../common/Loader';

// Minimal, generic admin table: columns config + row data in, markup
// out. Sorting/pagination/filtering deliberately stay in the page, not
// here - this only owns rendering + loading/empty state, reusing the
// existing (previously unused) .data-table CSS from styles/layout.css.
// overflow-x is scoped to the table's own wrapper so a wide table
// scrolls internally on narrow screens instead of the whole page.
function AdminDataTable({
  columns,
  rows,
  getRowKey,
  onRowClick,
  isLoading,
  loadingLabel = 'Loading...',
  emptyTitle = 'No results found.',
  emptyDescription,
}) {
  if (isLoading) {
    return <Loader label={loadingLabel} />;
  }

  if (rows.length === 0) {
    return <EmptyState title={emptyTitle} description={emptyDescription} />;
  }

  return (
    <div className="admin-table-wrap">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={getRowKey(row)}
              className={onRowClick ? 'admin-table-row-clickable' : ''}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
            >
              {columns.map((column) => (
                <td key={column.key}>
                  {column.render ? column.render(row) : row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AdminDataTable;
